<template>
    <div></div>
</template>

<script>
export default {
    data() {
        return {
            id: this.$route.params.id,
        }
    },
    created() {
        // 公司概况
        if (this.id == '1.html') {
            this.$router.push('/companyIntro')
        } else if (this.id == '2.html') {
            this.$router.push('/culture')
        } else if (this.id == '4.html') {
            this.$router.push('/recruit')
        } else if (this.id == '3.html') {
            this.$router.push('/Contact.html')
        }
    },
}
</script>
